export function doctorFormData(values, update = false) {
  const form = new FormData();
  if (update) form.append("_method", "PUT");
  const append = (key, value) => {
    if (value === undefined || value === null) return;
    if (Array.isArray(value)) {
      if (!value.length) form.append(key, "");
      else value.forEach((entry, index) => append(`${key}[${index}]`, entry));
    } else if (typeof value === "object" && !(value instanceof Blob)) {
      Object.entries(value).forEach(([child, entry]) => append(`${key}[${child}]`, entry));
    } else form.append(key, value);
  };
  const fields = {
    name: values.name, phone: values.phone, whatsapp: values.whatsapp,
    clinic_id: values.clinic_id, specialty: values.specialty,
    designation: values.designation, description: values.description,
    floor: values.floor, suite: values.suite,
    languages: values.languages, qualifications: values.qualification,
    publications: values.publications,
    online_booking_enabled: values.online_booking,
    appointment_policy_note: values.appointment_policy_note,
    sort_order: values.sort_order,
  };
  // The create example uses email; update accepts the multiple-email field.
  if (update) fields.emails = values.email;
  else {
    fields.email = values.email?.[0] || "";
    fields.emails = values.email;
  }
  if (values.online_booking === 1 || values.online_booking === true || values.online_booking === "1") {
    const selectedSessions = Object.entries(values.preferred_session || {}).reduce((result, [day, slots]) => {
      const selected = Object.keys(slots || {}).filter(slot => slots[slot]);
      if (selected.length) result[day.toLowerCase()] = selected;
      return result;
    }, {});
    if (Object.keys(selectedSessions).length) fields.preferred_sessions = selectedSessions;
  }
  Object.entries(fields).forEach(([key, value]) => append(key, value));
  if (values.profile_image instanceof Blob) append("profile_image", values.profile_image);
  (values.digital_name_card_files || []).forEach((file, index) => {
    if (file instanceof Blob) append(`digital_name_card_files[${index}]`, file);
  });
  return form;
}

export function doctorSchedule(value = {}) {
  return Object.fromEntries(["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map(day => {
    const slots = value[day.toLowerCase()] || value[day] || [];
    return [day, Object.fromEntries(["morning", "afternoon", "evening"].map(slot => [slot,
      Array.isArray(slots) ? slots.includes(slot) : Boolean(slots[slot]),
    ]))];
  }));
}
